import { FocusEvent } from "react";

export function selectAllText(event: FocusEvent<HTMLInputElement>) {
  event.target.select();
}
